(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ResultRange', ResultRange);

    ResultRange.$inject = ['$resource'];

    function ResultRange ($resource) {
        var resourceUrl =  'api/result-ranges/:id';

        return $resource(resourceUrl, {}, {
            'getAllByClinic': { url: 'api/result-ranges/by-clinic', method: 'POST', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init': {method: 'GET', url: 'api/result-ranges/init/:id'}
        });
    }
})();
